module.exports = __webpack_public_path__ + "static/img/ID_card_1.0ce92003.jpg";